export class DiseaseContentModel {
    public langId: number;
    public diseaseName: string;
    public diseaseDesc: string;
}